import { render, staticRenderFns } from "./Snippets.vue?vue&type=template&id=37ef1ebb&scoped=true"
import script from "./Snippets.vue?vue&type=script&lang=js"
export * from "./Snippets.vue?vue&type=script&lang=js"
import style0 from "./Snippets.vue?vue&type=style&index=0&id=37ef1ebb&prod&scoped=true&lang=css"
import style1 from "./Snippets.vue?vue&type=style&index=1&id=37ef1ebb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef1ebb",
  null
  
)

export default component.exports